var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurtleBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#4a7aff",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256v-3.5L400.7 141.2 388 172.4 280.8 65.3 160.5 205.7 145 169l-76 64 86.6 86.6 2.1 132.5 56.5 56.5A256 256 0 00512 256z",
    fill: "#0053bf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177 166s-21-42-55-31-53 98-53 98 79-69 85-24zm-6.8 169.3s-42.5-8.6-53.8 22.5 41.3 94.3 41.3 94.3-5.4-96.8 30.8-75.6z",
    fill: "#ffa300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335 166s21-42 55-31 53 98 53 98-79-69-85-24zm6.8 169.3s42.5-8.6 53.8 22.5-41.3 94.3-41.3 94.3 5.4-96.8-30.8-75.6z",
    fill: "#fe8205"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M294.2 153.9h-76.4V94.3a38.2 38.2 0 0176.4 0z",
    fill: "#ffa300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.2 94.3C294.2 73.2 277 56 256 56h-.4v98h38.6z",
    fill: "#fe8205"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279.8 415h-47.6c-50.5 0-91.4-41-91.4-91.4v-97.2c0-50.5 40.9-91.4 91.4-91.4h47.6c50.5 0 91.4 41 91.4 91.4v97.2c0 50.5-40.9 91.4-91.4 91.4z",
    fill: "#1ce8b7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.8 135h-24.2v280h24.2c50.5 0 91.4-41 91.4-91.4v-97.2c0-50.5-40.9-91.4-91.4-91.4z",
    fill: "#1dcc9e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M371.2 289.3v-30h-48.6l-19.9-34.5 42.8-62a91.7 91.7 0 00-24.2-17.9l-44.2 64.2h-42.2l-44.2-64.2a91.7 91.7 0 00-24.2 17.9l42.8 62-19.9 34.5h-48.6v30h48.6l20 34.5-42.7 63.5c7 7.2 15.1 13.3 24.1 17.8l44.2-65.7h42l44.2 65.7c9-4.5 17.1-10.6 24.1-17.8l-42.7-63.5 20-34.5zm-94.9 20.1h-40.6l-20.3-35.1 20.3-35.2h40.6l20.3 35.2z",
    fill: "#20d1a2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M371.2 289.3v-30h-48.6l-19.9-34.5 42.8-62a91.7 91.7 0 00-24.2-17.9l-44.2 64.2h-21.5v30h20.7l20.3 35.2-20.3 35.1h-20.7v30H277l44.2 65.7c9-4.5 17.1-10.6 24.1-17.8l-42.7-63.5 20-34.5h48.6z",
    fill: "#1bb287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtleBadge);
export default __webpack_public_path__ + "static/media/turtle-badge.a7295a855fdd49bc47694904efaa34c5.svg";
export { ForwardRef as ReactComponent };